import { createRouter, createWebHistory } from 'vue-router';
import ImportDirectOrder from './pages/direct-order/ImportDirectOrder.vue';
import ListDirectOrder from './pages/direct-order/ListDirectOrder.vue';
import ImportUpdateDirectOrderStatus from './pages/direct-order/ImportUpdateDirectOrderStatus.vue';
import SignIn from './pages/SignIn.vue';
import ForgotPassword from './pages/ForgotPassword.vue';
import Home from './pages/Home.vue';
import Account from './pages/Account.vue';
import { useAuthStore } from './stores/AuthStore';
import { PathDefinition } from './utils/PathDefinition';

const routes = [
    {
        path: PathDefinition.home,
        name: 'Home',
        component: Home,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.account,
        name: 'Account',
        component: Account,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.signIn,
        name: 'SignIn',
        component: SignIn,
        meta: { layout: 'BlankLayout' }
    },
    {
        path: PathDefinition.forgotPassword,
        name: 'ForgotPassword',
        component: ForgotPassword,
        meta: { layout: 'BlankLayout' }
    },
    {
        path: PathDefinition.listDirectOrder,
        name: 'ListDirectOrder',
        component: ListDirectOrder,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.importDirectOrder,
        name: 'ImportDirectOrder',
        component: ImportDirectOrder,
        meta: { layout: 'DefaultLayout' }
    },
    {
        path: PathDefinition.importUpdateDirectOrderStatus,
        name: 'ImportUpdateDirectOrderStatus',
        component: ImportUpdateDirectOrderStatus,
        meta: { layout: 'DefaultLayout' }
    }
];

const router = createRouter({ history: createWebHistory(), routes });

router.beforeEach(async (to) => {
    const publicPages = [PathDefinition.signIn, PathDefinition.forgotPassword];
    const authRequired = !publicPages.includes(to.path);
    const auth = useAuthStore();

    if (authRequired) {
        const authenticated = await auth.isAuthenticated();
        if (!authenticated) {
            auth.returnUrl = to.fullPath;
            return PathDefinition.signIn;
        }
    }
});
export default router;
